import { copilotRequestSchema } from './copilot-request.schema';
import { z } from 'zod/v4';

export const copilotRequestPagedCollectionSchema = z.object({
  totalCount: z.number(),
  data: z.array(copilotRequestSchema),
});

export type CopilotRequestPagedCollection = z.infer<
  typeof copilotRequestPagedCollectionSchema
>;
